// src/pages/Student/StudentResults.js

import React, { useState, useEffect } from 'react';
import { auth, db } from '../../firebase';
import { onAuthStateChanged } from 'firebase/auth';
import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  where,
} from 'firebase/firestore';
import ClassDetails from '../../components/student/ClassDetails'; // Import the new ClassDetails
import Preloader from '../../components/Preloader';

function StudentResults() {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const [classes, setClasses] = useState([]);
  const [selectedClass, setSelectedClass] = useState(null);

  useEffect(() => {
    // Check if user is signed in
    const unsubscribeAuth = onAuthStateChanged(auth, (currentUser) => {
      if (currentUser) {
        setUser(currentUser);
        loadStudentClasses(currentUser);
      } else {
        console.log('No user is signed in.');
        window.location.href = '/sign-in';
      }
    });

    // Cleanup on unmount
    return () => {
      unsubscribeAuth();
    };
  }, []);

  const loadStudentClasses = async (currentUser) => {
    try {
      const classCards = [];
      const currentUserUid = currentUser.uid;

      // Query enrollments where students array contains currentUserUid
      const enrollmentsRef = collection(db, 'enrollments');
      const q = query(
        enrollmentsRef,
        where('students', 'array-contains', currentUserUid)
      );
      const querySnapshot = await getDocs(q);

      for (const enrollmentDoc of querySnapshot.docs) {
        const classId = enrollmentDoc.id;
        const classDocRef = doc(db, 'classes', classId);
        const classDocSnap = await getDoc(classDocRef);

        if (classDocSnap.exists()) {
          const classData = classDocSnap.data();
          classCards.push({
            id: classId, // Change to 'id' to match the prop used in ClassDetails
            ...classData,
          });
        }
      }

      setClasses(classCards);
      setLoading(false);
    } catch (error) {
      console.error('Error loading student classes:', error);
      setLoading(false);
    }
  };

  if (loading) {
    return <Preloader />;
  }

  return (
    <>
      {/* Main container uses the theme variables and Tailwind utility classes */}
      <main className="bg-[var(--bg-color)] text-[var(--text-color)] transition-all">
        <section className="mx-auto max-w-7xl px-0 py-0">
          {selectedClass ? (
            <ClassDetails
              selectedClass={selectedClass}
              closeClass={() => setSelectedClass(null)}
              user={user}
            />
          ) : (
            <>
              {/* Grid for class cards */}
              <div
                id="class-cards"
                className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3"
              >
                {classes.map((classItem) => (
                  <div
                    key={classItem.id}
                    onClick={() => setSelectedClass(classItem)}
                    className="cursor-pointer rounded-lg border p-4 transition-all duration-200 hover:-translate-y-0.5 hover:shadow-md"
                    style={{ backgroundColor: 'var(--card-bg)', borderColor: 'var(--border-color)', boxShadow: 'var(--shadow-sm)' }}
                  >
                    <h3 className="mb-2 truncate text-lg font-semibold">
                      {classItem.class_name}
                    </h3>
                  </div>
                ))}
              </div>

              {/* No classes message */}
              {classes.length === 0 && (
                <div className="mt-4 rounded-lg border p-8 text-center" style={{ borderColor: 'var(--border-color)', backgroundColor: 'var(--card-bg)' }}>
                  <p className="text-[var(--muted-color)]">
                    You are not enrolled in any classes.
                  </p>
                </div>
              )}
            </>
          )}
        </section>
      </main>
    </>
  );
}

export default StudentResults;
